import { useEffect } from 'react';
import { AppUpdate, AppUpdateAvailability, AppUpdateInfo } from '@capawesome/capacitor-app-update';
import { useWindow } from '../contexts/WindowContext';
import { isPlatform } from '../utilities/platform';
import { UpdateAvailable } from '../windows/UpdateAvailable';

const isStoreVersionNewer = (info: AppUpdateInfo): boolean => {
    if (isPlatform('android')) {
        return parseInt(info.availableVersionCode ?? '') > parseInt(info.currentVersionCode);
    }
    return info.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE;
};

/**
 * Checks the store once per app launch, fire-and-forget: the native lookup
 * (itunes.apple.com on iOS) can hang for a minute on a bad network, so nothing waits for it.
 */
export const useAppUpdateCheck = (): void => {
    const { openWindow } = useWindow();

    useEffect(() => {
        if (!isPlatform('hybrid')) return;
        AppUpdate.getAppUpdateInfo()
            .then((info) => {
                if (isStoreVersionNewer(info)) openWindow?.({ component: UpdateAvailable });
            })
            .catch(() => undefined);
    }, []);
};
